<script>
  import tippy from 'tippy.js';

  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');

  import { getProfileStore } from '@stores/profile';
  let groupsStore = getProfileStore('groupsStore');

  import { onMount } from 'svelte';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';

  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';

  export let tooltipMessageContent = 'List optimized!';
  export let location;
  export let groupId;
  export let mobile = false;
  let currentUser = getCurrentUserStore('default');

  let optimizeInfoLink =
    'https://docs.google.com/presentation/d/e/2PACX-1vQlQLmQLEd65EOpjel3-YaEp3Wher6-xX_ASvZNIyIctANGA7XOoWg8TKyX6UvLLWeZeBqxM2SuQ317/pub?start=false&loop=true&delayms=2000';
  let group;
  let showGroupOptimizedModal = false;

  let setupTippy = (node, data) => {
    if (mobile) {
      return;
    }

    let instance = tippy(node, {
      content: data,
    });

    return {
      destroy() {
        try {
          instance.destroy();
        } catch {}
      },
    };
  };

  onMount(() => {
    group = groupId ? groupsStore.find(groupId) : groupStore;
    let unsubGroup = group.subscribe((x) => (group = x));

    return () => {
      unsubGroup();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .group-optimized {
    margin-right: 16px;
    cursor: pointer;

    &.profile-cover-photos {
      padding-top: 10px;

      &.mobile {
        padding-top: 9px;
        margin-right: 8px;
      }
      > a > img {
        height: 20px;
      }
    }

    &.profile-new {
      padding-top: 14px;
      &.mobile {
        padding-top: 12px;
        margin-right: 8px;
      }
      > a > img {
        height: 20px;
      }
    }
    &.profile {
      padding-top: 9px;
      &.mobile {
        padding-top: 10px;
        margin-right: 8px;
      }
      > a > img {
        height: 18px;
      }
    }
  }

  .ui-content {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 20px;
  }

  .ui-header {
    font-weight: 700;
    font-size: 28px;
    font-family: 'Helvetica Neue';
    line-height: 40px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 530px;
    margin-bottom: 30px;

    .modal-icon {
      margin-bottom: 40px;
    }
  }

  .ui-body {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: $neutral-gray;

    :global(.bn-button.group-optimize-button) {
      width: 317px;
      margin-top: 30px;
    }

    :global(.bn-button.group-optimize-button.mobile) {
      margin-top: 30px;
      width: 100%;
      line-height: 20px;
      height: 52px;
    }

    :global(br.small) {
      display: none;
    }
  }

  @media (max-width: 400px) {
    .ui-body :global(br.small) {
      display: inline;
    }
  }
</style>

{#if group && group.permissions.edit && group.optimized_score}
  <div
    class="group-optimized"
    class:profile={location === 'profile'}
    class:profile-new={location === 'profileNew'}
    class:profile-cover-photos={location === 'profileCoverPhotos'}
    class:mobile={mobile}
    use:setupTippy={tooltipMessageContent}>
    <a
      href="#"
      on:click|preventDefault|stopPropagation={() => {
        showGroupOptimizedModal = true;
        Track.listOptimizedClicked({ currentUser: currentUser, group: group });
      }}>
      <img alt="optimized" height={25} src="/images/optimized-logo.svg" />
    </a>
  </div>
  <Modal bind:show={showGroupOptimizedModal}>
    <div slot="content">
      <div class="ui-content">
        <div class="ui-header">
          <img alt="logo" class="modal-icon" height={80} src="/images/optimized-logo.svg" /> <br />

          Your list is Optimized <br /> for Discovery!
        </div>
        <div class="ui-body">
          Whenever you see this Optimized Badge on your list, it means your list is really high quality and Benable can
          help drive extra traffic to it. Optimized lists can be featured on Discover, rank higher in search results,
          and get indexed on search engines. All of that will help drive traffic back to you and your recommendations!
          <br /><br />
          How can you earn the Optimized Badge on a list? Click below to see some tips!
          <br />
          <Button
            text="How to unlock {mobile ? '<br class="small" />' : ''} the Optimized Badge"
            class="group-optimize-button {mobile ? 'mobile' : ''}"
            on:click={() => {
              window.open(optimizeInfoLink, '_blank');

              Track.listOptimizedButtonClicked({ currentUser: currentUser, group: group });
            }} />
        </div>
      </div>
    </div>
  </Modal>
{/if}
